import React, { useCallback, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Container } from 'components/UI';
import { Slider, SliderControl } from 'components/Slider';
import Slide from './Slide';

import * as styles from './Testimonials.module.scss';

export default function Testimonials({ description, slides }) {
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });
  const sliderRef = useRef(null);
  const [current, setCurrent] = useState(1);

  const setCurrentIndex = useCallback((prev, next) => {
    setCurrent(next + 1);
  }, []);

  const handleNext = useCallback(() => {
    sliderRef.current.slickNext();
  }, [sliderRef]);

  const handlePrev = useCallback(() => {
    sliderRef.current.slickPrev();
  }, [sliderRef]);

  const settings = {
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <Container className={styles.container} background="transparent">
      <div className={styles.layout}>
        <p className={styles.description}>{description}</p>
        <div className={styles.sliderWrapper} ref={inViewRef}>
          {inView && (
            <>
              <Slider ref={sliderRef} beforeChange={setCurrentIndex} {...settings}>
                {slides.map(slide => (
                  <Slide key={slide.name} {...slide} />
                ))}
              </Slider>
              {slides.length > 1 && (
                <SliderControl
                  className={styles.sliderControls}
                  current={current}
                  to={slides.length}
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                />
              )}
            </>
          )}
        </div>
      </div>
    </Container>
  );
}
